import React from 'react';
import 'twin.macro';
import { useStaticQuery, graphql, Link } from 'gatsby';

import { Container, Heading, Subtitle, Button } from '../atoms';
import SanityImage from '../global/SanityImage';

const query = graphql`
  query fetchBrandLogoQuery {
    allSanityBrand {
      nodes {
        _id
        title
        slug {
          current
        }
        image {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`;

const BrandBlock = (props) => {
  const { title, description } = props;
  const { allSanityBrand } = useStaticQuery(query);
  const data = allSanityBrand.nodes;

  return (
    <Container tw="bg-slate text-center">
      <Heading>{title}</Heading>
      <div tw="border my-6 border-black m-auto w-24" />
      <Subtitle tw="mt-6">{description}</Subtitle>
      <div tw="py-10 grid grid-cols-2 md:grid-cols-5 gap-6">
        {data &&
          data.map((item) => {
            if (!item.image.asset) return null;
            return (
              <div
                tw="max-w-sm mx-auto flex items-center justify-center"
                key={item._id}
              >
                {item.image && item.image.asset && (
                  <SanityImage
                    fluid={item.image.asset.gatsbyImageData}
                    alt={item.title || 'Brand'}
                    objectFit="contain"
                    width={100}
                  />
                )}
              </div>
            );
          })}
      </div>
      <Link to="/" tw="flex justify-center">
        <Button tw="md:w-3/12">SEE ALL OUR BRANDS </Button>
      </Link>
    </Container>
  );
};

export default BrandBlock;
